import { CSSResult, LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import css from "./maz-plushie-thumbnail.scss";

@customElement("maz-plushie-thumbnail")
export class MaziCraftPlushieThumbnail extends LitElement {
  static get styles(): CSSResult { return css; }

  /**
   * The image URL
   */
  @property({type: String, reflect: true}) skinUrl = "";

  /**
   * The name
   */
  @property({type: String, reflect: true}) name = "";

  /**
   * Scroll to the top if the user clicks on a thumbnail
   */
  private scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
  

  /**
   * Render the plushie thumbnail
   * @returns HTML Template
   */
  render(): TemplateResult {
    return html`
      <div 
        class="container" 
        title="${this.name}"
        @click=${() => this.scrollToTop()}
      >
        <div class="layer" id="base" style="background-image: url(${this.skinUrl});"></div>
        <div class="layer" id="outer" style="background-image: url(${this.skinUrl});"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "maz-plushie-thumbnail": MaziCraftPlushieThumbnail;
  }
}
